export default __webpack_public_path__ + "static/Image039_cut-2f2bc27a9fa49e5d8936bd1cbcefa983.png";